/**
 * VisionENVisionPageView
 *
 * Page component for VisionENVisionPageView
 * Path: /vision
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { VisionENVisionPageView as __VisionENVisionPageView } from '@/components/traits/VisionENVisionPageView';
import { VisionENVisionAnalyticsView as __VisionENVisionAnalyticsView } from '@/components/traits/VisionENVisionAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';
import { usePageHead } from '@almadar/ui/hooks';

interface VisionENVisionPageViewProps {
  // Add any page-level props here
}

export function VisionENVisionPageView(_props: VisionENVisionPageViewProps) {
  const __location = useLocation();
  const __navState = (__location.state ?? {}) as EventPayload;

  usePageHead({ "title":["i18n/t","std-almadar-vision:meta.title"],"description":["i18n/t","std-almadar-vision:meta.description"],"access":"public","indexing":"index","origin":"https://almadar.io","siteName":"Almadar","alternates":[{"locale":"en","path":"/vision"},{"locale":"ar","path":"/ar/vision"},{"locale":"sl","path":"/sl/vision"}],"defaultLocale":"en", path: __location.pathname });

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__VisionENVisionPageView config={{ initPayload: __navState }} />
          <__VisionENVisionAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default VisionENVisionPageView;
